import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import styles from "./Navbar.module.scss";

// Components
import MobileMenu from "components/Shared/MobileMenu";

// Properties
import properties from "properties.json";

// Assets
import EEPLogo from "assets/images/png/EEP-Logo.png";

// Icons
import { barsIcon } from "helpers/icons";

const Navbar = () => {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  const activeClassName = styles.active;

  return (
    <div className={styles.navbar}>
      <div className={styles.logo}>
        <Link to="/">
          <img
            src={require(`../../../assets/${properties.appearence.logo}`)}
            alt="IEEE KSB Logo"
          />
        </Link>
      </div>
      <div className={styles.menu}>
        <NavLink
          className={({ isActive }) =>
            styles.navItem + " " + (isActive ? activeClassName : undefined)
          }
          to="/"
        >
          <span>Home</span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            styles.navItem + " " + (isActive ? activeClassName : undefined)
          }
          to="/about"
        >
          <span>About</span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            styles.navItem + " " + (isActive ? activeClassName : undefined)
          }
          to="/team"
        >
          <span>Team</span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            styles.navItem + " " + (isActive ? activeClassName : undefined)
          }
          to="/events"
        >
          <span>Events</span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            styles.navItem + " " + (isActive ? activeClassName : undefined)
          }
          to="/forms"
        >
          <span>Forms</span>
        </NavLink>
      </div>
      <div className={styles.mobileMenu}>
        <div
          className={styles.menuIcon}
          onClick={() => setOpenMobileMenu(true)}
        >
          {barsIcon(25, 25)}
        </div>
        <MobileMenu
          openMobileMenu={openMobileMenu}
          setOpenMobileMenu={setOpenMobileMenu}
        />
      </div>
    </div>
  );
};

export default Navbar;
